import React, { useState } from "react";
import { axiosInstance } from "contexts/axiosApiInstance";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { Button } from "components/common/Button";
import { AuthHeader } from "@/components/authentication/common/AuthHeader";
export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) {
      setError("Please enter your email address");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setError("Please enter a valid email address");
      return;
    }
    setError("");
    try {
      await axiosInstance.post("/api/auth/forgotpassword", { email: trimmed });
    } catch {
      // Show success regardless to not leak account existence
    }
    setSent(true);
  };

  return (
    <section className="auth-page">
      <div className="flex flex-col justify-center items-center min-h-full px-6 py-12 lg:px-8">
        <div className="w-full sm:max-w-sm flex flex-col gap-8">
          <AuthHeader
            title={sent ? "Reset Link Sent" : "Forgot Password ?"}
            icon={
              sent ? (
                <EmailOutlinedIcon
                  style={{ fontSize: 64, color: "var(--color-fg)" }}
                />
              ) : undefined
            }
          />

          {sent ? (
            <>
              <p className="text-center text-fg-muted-regular">
                We have sent a reset password link to your email.
              </p>

              <p className="text-center text-fg-muted-medium">
                <button
                  onClick={() => window.history.back()}
                  className="cursor-pointer  hover:underline"
                >
                  Go back to Login
                </button>
              </p>
            </>
          ) : (
            <>
              <p
                className="text-center"
                style={{ color: "var(--color-fg-muted)", fontSize: "13px" }}
              >
                A reset link will be sent to your email.
              </p>

              <form
                noValidate
                onSubmit={handleSubmit}
                className="flex flex-col gap-8"
              >
                <div className="relative">
                  <input
                    id="email"
                    type="email"
                    required
                    className="auth-input"
                    placeholder="Email address"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setError("");
                    }}
                  />
                  {error && <p className="auth-error">{error}</p>}
                </div>

                <Button
                  type="submit"
                  variant="primary"
                  size="lg"
                  fullWidth={true}
                >
                  Continue
                </Button>
              </form>

              <p
                className="text-center"
                style={{ color: "var(--color-fg-muted)", fontSize: "13px" }}
              >
                <button
                  onClick={() => window.history.back()}
                  className="cursor-pointer font-medium hover:underline"
                  style={{ color: "var(--color-fg)", fontSize: "13px" }}
                >
                  Go back to Login
                </button>
              </p>
            </>
          )}
        </div>
      </div>
    </section>
  );
};
